import React, { Component } from 'react';
import './App.css';
import joni from './joni.png';
import chachi from './chachi.png';


class App extends Component {
  
  render() {
    return (
      
      <div>Coming soon...</div>
    // <div className="content">
    //   <div className="row"><h1>SVHS Finest</h1></div>
    //   <figure>
    //   <img src={joni} alt="Joni" title="Gentle lover"/>
    //       <figcaption>Gentle Lover</figcaption>
    //   </figure>
    //   <figure>
    //       <img src={chachi} alt="Chachi" title="Aggressive snuggler"/>
    //       <figcaption>Aggressive snuggler</figcaption>
    //     </figure>
    // </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js